module.exports = __webpack_public_path__ + "img/youpaq-label-yellow.5f9e6de2.png";